module.exports = __webpack_public_path__ + "public/img/ico-schematics-inverter-shadow.5c3517e7.svg";